import React from 'react';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AdminDashboard from './pages/AdminDashboard';
import StudentDashboard from './pages/StudentDashboard';

// Protected route wrapper
const ProtectedRoute = ({ children, role: requiredRole }) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');

  if (!token || role !== requiredRole) {
    return <Navigate to="/login" />;
  }

  return children;
};

// Define routes
const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/login" />,
  },
  {
    path: '/login',
    element: localStorage.getItem('token') ? (
      <Navigate to={localStorage.getItem('role') === 'admin' ? '/admin' : '/student'} />
    ) : (
      <LoginPage />
    ),
  },
  {
    path: '/signup',
    element: localStorage.getItem('token') ? <Navigate to="/" /> : <SignupPage />,
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute role="admin">
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/student',
    element: (
      <ProtectedRoute role="student">
        <StudentDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <h2>404 Not Found</h2>,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
